var map = {
	"./appset.svg": "EE85",
	"./atta.svg": "MKNp",
	"./book.svg": "W9Um",
	"./clock.svg": "z5wF",
	"./cms-chat.svg": "E3WA",
	"./cms.svg": "fHET",
	"./download.svg": "+H2/",
	"./example.svg": "OOLB",
	"./eye-slash.svg": "iKpW",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./help.svg": "35H+",
	"./home-item-icon.svg": "1Vgu",
	"./home-item-icon1.svg": "Fasd",
	"./home-item-icon10.svg": "eu1J",
	"./home-item-icon11.svg": "uj0q",
	"./home-item-icon12.svg": "yMAh",
	"./home-item-icon2.svg": "DLjV",
	"./home-item-icon3.svg": "InAa",
	"./home-item-icon4.svg": "8ARW",
	"./home-item-icon5.svg": "omDt",
	"./home-item-icon6.svg": "8u42",
	"./home-item-icon7.svg": "MFss",
	"./home-item-icon8.svg": "qI2k",
	"./home-item-icon9.svg": "LReq",
	"./home-item-more.svg": "4mfW",
	"./home.svg": "U9Ws",
	"./icon-danwei.svg": "Yb71",
	"./icon-dh.svg": "jcns",
	"./icon-down-more.svg": "W2Zt",
	"./icon-mima.svg": "Jf9S",
	"./icon-right-more.svg": "jiVY",
	"./icon-sj.svg": "/pwi",
	"./icon-yanzhengma.svg": "ykwP",
	"./icon-zhanghao.svg": "teEV",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./nav-sp.svg": "zz+L",
	"./nav-wd.svg": "SpVV",
	"./notice.svg": "MqGM",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./qrcode.svg": "HQ2j",
	"./question-circle.svg": "mS/Y",
	"./seting.svg": "MZ0a",
	"./shop.svg": "hert",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./specialty.svg": "oWVY",
	"./sync.svg": "aBWl",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user-icon.svg": "KYAJ",
	"./user.svg": "VdD3",
	"./user2.svg": "AxbE",
	"./users-cog.svg": "worc",
	"./wechat.svg": "pYJ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 97